var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table is-fullwidth is-striped is-narrow" },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.table.headers, function (header, index) {
            return _c(
              "th",
              {
                class: {
                  "has-text-right": _vm.table.alignments[index] === "right",
                  "has-text-left": _vm.table.alignments[index] === "left",
                },
                staticStyle: {
                  "{ 'width'":
                    "table.widths[index] ? (table.widths[index] + '%') : undefined }",
                },
              },
              [
                _vm.table.abbreviations[index]
                  ? _c("abbr", { attrs: { title: header } }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.table.abbreviations[index])),
                      ]),
                    ])
                  : [_vm._v(_vm._s(header))],
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.table.body, function (row, rowIndex) {
          return _c(
            "tr",
            _vm._l(row, function (cell, cellIndex) {
              return _c(
                "td",
                {
                  class: {
                    "has-text-right":
                      _vm.table.alignments[cellIndex] === "right",
                    "has-text-left": _vm.table.alignments[cellIndex] === "left",
                    "has-background-tablehighlight": _vm.hasHighlight(
                      rowIndex,
                      cellIndex
                    ),
                  },
                },
                [_vm._v("\n      " + _vm._s(cell) + "\n    ")]
              )
            }),
            0
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }